import React from 'react';
import { Typography } from '@wds/typography';
import { PACKAGES } from '~app/pages/Pricing/lib/constants';
import { BylineProps } from '~pricing/lib/summaryPackages';

export default function PackageByline({ byline, packageName }: BylineProps): JSX.Element {
  if (!byline) {
    return <></>;
  }
  return (
    <Typography
      component={packageName === PACKAGES.Enterprise ? 'p' : 'h4'}
      variant="body"
      data-testid="PackageByline"
      align="center"
    >
      {byline}
    </Typography>
  );
}
